<template>
  <div class="section-new-order">
    <div class="col-8 col-lg-8 col-xl-5 mx-auto py-xl-2">
      <div>
        <h3 class="section-title-centered text-uppercase" v-translate>order level</h3>
        <div class="text-center pt-4">
          <button v-for="level in levels" :key="level.id"
            class="btn btn-default"
            :class="{ 'btn--active': selectedItem.orderLevel === level.id }"
            @click="changeOrderLevel(level)"
          >
            {{ level.name }}
          </button>
        </div>
        <div class="btns-footer mt-3 text-center">
          <button class="btn btn-cancel px-4" @click="onCancel" v-translate>Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TOGGLE_ORDER_LEVEL_BUTTON } from '@/store/mutation-types';

export default {
  name: 'OrderLevel',
  data() {
    return {
      levels: [],
    };
  },
  computed: {
    orderLevels() { return this.getArray('orderLevels') },
    selectedItem() { return this.getMap('selectedItem', true) },
  },
  methods: {
    changeOrderLevel(level) {
      this.selectedItem.orderLevel = level.id;
      this.$router.replace({ name: 'order' });
    },
    onCancel() {
      const currentRouteName = this.$route.name;
      this.$router.back();

      setTimeout(() => {
        if (this.$route.name === currentRouteName) {
          this.$router.replace({ name: 'order' });
        }
      }, 120);
    },
  },
  mounted() {
    if (this.selectedItem && !this.selectedItem.empty) {
      this.$store.commit(TOGGLE_ORDER_LEVEL_BUTTON, true);
      const article = this.getObject(this.selectedItem.product, 'articles');
      this.levels = this.orderLevels.filter(({ productGroup }) => productGroup === article.productGroup);
    } else {
      this.$router.replace({ name: 'order' });
    }
  },
};
</script>
